<script lang="ts">
	import { DevFacebookPixel } from '#lib/features/tag-managers/components/DevFacebookPixel/index.js';
	import { FacebookPixel } from '#lib/features/tag-managers/components/FacebookPixel/index.js';
	import { GoogleTagManagers } from '#lib/features/tag-managers/components/GoogleTagManagers/index.js';
	import { HubSpotTracking } from '#lib/features/tag-managers/components/HubSpotTracking/index.js';
	import { MicrosoftTagManagers } from '#lib/features/tag-managers/components/MicrosoftTagManagers/index.js';
	import { TwitterTagManagers } from '#lib/features/tag-managers/components/TwitterTagManagers/index.js';
	import { isOnProductionOnly } from '#lib/utils/env/isOnProductionOnly/isOnProductionOnly.js';
	import { isCypress } from '$global/utils/isCypress/isCypress';
</script>

<HubSpotTracking />
<GoogleTagManagers />
<TwitterTagManagers />
{#if typeof window !== 'undefined' && !isCypress()}
	<MicrosoftTagManagers />
{/if}

{#if isOnProductionOnly()}
	<FacebookPixel />
{:else}
	<DevFacebookPixel />
{/if}
